"use strict";
import { atomWithStorage } from "jotai/utils";
export const walletModeAtom = atomWithStorage("topaz_wallet_mode", "smart");
